import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from '../../icons/Icon.js'

const SIZE_TO_FS = {
  'xx-sm': 'fs-00',
  'x-sm': 'fs-01',
}

export default function ButtonIcon({
  className,
  name,
  iconClassName,
  onClick,
  text = '',
  size = 'x-sm',
}) {
  const fsClass = SIZE_TO_FS[size] || size

  return (
    <button
      type="button"
      className={classNames(
        'inline-text-button no-underline v-align-middle margin-top-5 margin-left-5',
        className,
      )}
      onClick={onClick}
    >
      <Icon
        name={name}
        className={classNames(iconClassName, fsClass, {
          'margin-right-3': !text,
          'margin-right-5': !!text,
        })}
      />
      {text && (
        <span
          className={classNames('v-align-middle', {'fs-00': size === 'xx-sm'})}
        >
          {text}
        </span>
      )}
    </button>
  )
}

ButtonIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.node,
  size: PropTypes.oneOf(['x-sm', 'xx-sm']),
}
